
export default {
  layout: 'replace',
  beforeMount() {
  }
}
